import React from "react";
import { Routes, Route } from "react-router-dom";
import { Login, CreateTicket, ResetPassword, VerifyEmail, Payments, RecoverUsername, Register, SchoolRegistration, EmailSignature, UnregisterUser, LoginSuccess } from 'pages'
import { Main, ThankYou } from 'components'
import { app } from "./routes";
import { PrivateRoutesApp, PrivateRoutesAuth } from ".";

const CreateRouter = () => {
    return (
        <Routes>
            <Route exact path={app.unregisterUser} element={
                <PrivateRoutesAuth>
                    <UnregisterUser />
                </PrivateRoutesAuth>
            } />
            <Route exact path={app.loginSuccess} element={
                <PrivateRoutesAuth>
                    <LoginSuccess />
                </PrivateRoutesAuth>
            } />
            <Route exact path={app.login} element={
                <PrivateRoutesAuth>
                    <Login />
                </PrivateRoutesAuth>
            } />
            <Route exact path={"/reset/*"} element={
                <PrivateRoutesAuth>
                    <ResetPassword />
                </PrivateRoutesAuth>
            } />
            <Route exact path={app.recoverUsername} element={
                <PrivateRoutesAuth>
                    <RecoverUsername />
                </PrivateRoutesAuth>
            } />
            <Route exact path={app.thankYou} element={
                <ThankYou />
            } />
            <Route exact path={"/verify/:token"} element={
                <PrivateRoutesAuth>
                    <VerifyEmail />
                </PrivateRoutesAuth>
            } />
            <Route exact path={"/register/*"} element={
                <PrivateRoutesAuth>
                    <Register />
                </PrivateRoutesAuth>
            }>
            </Route>
            <Route exact path={`${app.schoolRegistartion}/*`} element={
                <PrivateRoutesAuth>
                    <SchoolRegistration />
                </PrivateRoutesAuth>
            }></Route>
            <Route exact path={app.payments} element={
                <Payments />
            }>
            </Route>
            <Route exact path={app.emailSignature} element={
                <EmailSignature />
            }>
            </Route>
            <Route exact path={app.contactUs} element={
                <CreateTicket />
            }>
            </Route>
            <Route exact path="/*" element={
                <PrivateRoutesApp>
                    <Main />
                </PrivateRoutesApp>
            } />
        </Routes>
    );
}

export default CreateRouter
